/**
 * Tag color palette + Tailwind class mapping.
 *
 * Mirror of backend/src/lib/tag-colors.ts. The 10 colors match the
 * design-system avatar palette (.claude/docs/design-system.md → Avatars).
 *
 * Legacy 'gray' values (created before the whitelist) render as `slate`.
 */

export const VALID_TAG_COLORS = [
  'sage',
  'olive',
  'coral',
  'teal',
  'violet',
  'slate',
  'indigo',
  'wine',
  'plum',
  'rust',
] as const

export type TagColor = (typeof VALID_TAG_COLORS)[number]

/**
 * Tailwind utility class for the chip background. We rely on inline
 * arbitrary-value class names so adding/removing palette entries doesn't
 * require touching tailwind.config.ts.
 */
export const TAG_COLOR_CLASSES: Record<TagColor, string> = {
  sage: 'bg-[#467A60] text-white',
  olive: 'bg-[#6B7A2E] text-white',
  coral: 'bg-[#C0532E] text-white',
  teal: 'bg-[#287087] text-white',
  violet: 'bg-[#6F4DB8] text-white',
  slate: 'bg-[#455473] text-white',
  indigo: 'bg-[#3F4F9E] text-white',
  wine: 'bg-[#7A2E3D] text-white',
  plum: 'bg-[#8C3D7A] text-white',
  rust: 'bg-[#9C4724] text-white',
}

/**
 * Resolve any color string (including legacy 'gray' or junk) to a Tailwind
 * class. Falls back to `slate` for unknown values so chips always render
 * with consistent contrast.
 */
export function tagClassFor(color: string | undefined | null): string {
  if (!color || !(color in TAG_COLOR_CLASSES)) {
    return TAG_COLOR_CLASSES.slate
  }
  return TAG_COLOR_CLASSES[color as TagColor]
}
